// Employee Session V2 — action type constants (spec §3-§9, §11)

export const LOAD_SESSION_REPORTS = 'LOAD_SESSION_REPORTS';
export const STORE_SESSION_REPORTS = 'STORE_SESSION_REPORTS';
export const CLEAR_SESSION_REPORTS = 'CLEAR_SESSION_REPORTS';
export const SESSION_REPORTS_FAILED = 'SESSION_REPORTS_FAILED';

// Bonus
export const EDIT_BONUS_V2 = 'EDIT_BONUS_V2';
export const DELETE_BONUS_V2 = 'DELETE_BONUS_V2';
export const ADD_BONUS_V2 = 'ADD_BONUS_V2';
export const SUBMIT_BONUS_DECISION = 'SUBMIT_BONUS_DECISION';

// Raffle
export const EDIT_RAFFLE_V2 = 'EDIT_RAFFLE_V2';
export const DELETE_RAFFLE_V2 = 'DELETE_RAFFLE_V2';
export const ADD_RAFFLE_V2 = 'ADD_RAFFLE_V2';
export const SUBMIT_RAFFLE_DECISION = 'SUBMIT_RAFFLE_DECISION';

// Ticket Out
export const EDIT_TICKETOUT_V2 = 'EDIT_TICKETOUT_V2';
export const DELETE_TICKETOUT_V2 = 'DELETE_TICKETOUT_V2';

// Transaction (Bank / Expense)
export const EDIT_TRANSACTION_V2 = 'EDIT_TRANSACTION_V2';
export const DELETE_TRANSACTION_V2 = 'DELETE_TRANSACTION_V2';
export const ADD_TRANSACTION_V2 = 'ADD_TRANSACTION_V2';

// Reconciliation — manager override of the closing-cash amount
export const EDIT_CASH_LEFT_V2 = 'EDIT_CASH_LEFT_V2';

// Audit log + owner settings
export const LOAD_AUDIT_LOG = 'LOAD_AUDIT_LOG';
export const STORE_AUDIT_LOG = 'STORE_AUDIT_LOG';
export const LOAD_OWNER_AUDIT_SETTINGS = 'LOAD_OWNER_AUDIT_SETTINGS';
export const STORE_OWNER_AUDIT_SETTINGS = 'STORE_OWNER_AUDIT_SETTINGS';
export const SAVE_OWNER_AUDIT_SETTINGS = 'SAVE_OWNER_AUDIT_SETTINGS';

// Duplicate detection (Bonus)
export const LOAD_DUPLICATE_SCORES = 'LOAD_DUPLICATE_SCORES';
export const STORE_DUPLICATE_SCORES = 'STORE_DUPLICATE_SCORES';

// Local UI state — decisions made during audit before they hit the server
export const RECORD_LOCAL_DECISION = 'RECORD_LOCAL_DECISION';
export const CLEAR_LOCAL_DECISIONS = 'CLEAR_LOCAL_DECISIONS';
